module.exports = __webpack_public_path__ + "static/media/Pod.4dec738d.png";